import { render, staticRenderFns } from "./cardMessage.vue?vue&type=template&id=835ceb62&scoped=true&"
import script from "./cardMessage.vue?vue&type=script&lang=js&"
export * from "./cardMessage.vue?vue&type=script&lang=js&"
import style0 from "./cardMessage.vue?vue&type=style&index=0&id=835ceb62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835ceb62",
  null
  
)

export default component.exports